/* ============================================================
   DeckWächter — Pack-Opener Animation (nur Seite /pages/pack-offner)
   Umschließt window.DW.open(): zeigt ein echtes Booster-Pack, das
   aufgerissen, zusammengeknüllt und weggeworfen wird – danach erscheint
   die Belohnung (Rabatt/Karte) der bestehenden Logik. Kein Eingriff in
   die Seiten-HTML; rein additiv über das Theme.
   ============================================================ */
(function () {
  if (window.__dwPackAnim) return;
  if (location.pathname.indexOf('/pages/pack-offner') === -1) return;
  window.__dwPackAnim = true;

  var css = document.createElement('style');
  css.textContent =
    ".dwpa-ov{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;background:radial-gradient(circle at 50% 45%,rgba(40,10,6,.86),rgba(4,2,3,.94));backdrop-filter:blur(3px);font-family:'Oswald','Inter',sans-serif;}" +
    ".dwpa-ov.on{display:flex;}" +
    ".dwpa-ov.fade{opacity:0;transition:opacity .4s ease;}" +
    ".dwpa-stage{position:relative;width:240px;height:360px;display:flex;align-items:center;justify-content:center;}" +
    ".dwpa-burst{position:absolute;width:30px;height:30px;border-radius:50%;background:radial-gradient(circle,#fff,#ffd27a 30%,#ff6a00 60%,transparent 72%);opacity:0;transform:scale(.2);z-index:2;pointer-events:none;}" +
    ".dwpa-burst.go{animation:dwpaBurst .65s ease-out forwards;}" +
    "@keyframes dwpaBurst{0%{opacity:0;transform:scale(.2);}25%{opacity:1;}100%{opacity:0;transform:scale(13);}}" +
    ".dwpa-pack{position:relative;width:198px;height:300px;border-radius:12px;background:linear-gradient(158deg,#3a1410 0%,#1a0708 45%,#2a0d0a 100%);border:1px solid rgba(255,130,90,.45);box-shadow:0 24px 60px rgba(0,0,0,.6),0 0 44px rgba(255,90,42,.32),inset 0 0 34px rgba(255,106,0,.16);overflow:hidden;transform-origin:center;animation:dwpaDrop .55s cubic-bezier(.2,1.3,.4,1) both;}" +
    "@keyframes dwpaDrop{0%{transform:translateY(-120px) scale(.7) rotate(-6deg);opacity:0;}100%{transform:translateY(0) scale(1) rotate(0);opacity:1;}}" +
    ".dwpa-pack::after{content:'';position:absolute;top:0;bottom:0;left:-60%;width:50%;background:linear-gradient(100deg,transparent,rgba(255,235,190,.32),transparent);transform:skewX(-18deg);animation:dwpaGlanz 2.2s linear infinite;}" +
    "@keyframes dwpaGlanz{0%{left:-60%;}60%,100%{left:130%;}}" +
    ".dwpa-pack.shake{animation:dwpaShake .5s ease-in-out 2;}" +
    "@keyframes dwpaShake{0%,100%{transform:translateX(0) rotate(0);}20%{transform:translateX(-7px) rotate(-2deg);}40%{transform:translateX(7px) rotate(2deg);}60%{transform:translateX(-5px) rotate(-1.5deg);}80%{transform:translateX(5px) rotate(1.5deg);}}" +
    ".dwpa-pack.crumple{animation:dwpaCrumple .75s cubic-bezier(.5,0,.7,1) forwards;}" +
    "@keyframes dwpaCrumple{0%{transform:scale(1) rotate(0);}30%{transform:scale(.9,1.05) skew(-4deg,2deg);}60%{transform:scale(.55,.6) skew(10deg,-6deg) rotate(-14deg);filter:brightness(.7);}100%{transform:translate(-280px,300px) scale(.18) rotate(-220deg);opacity:0;filter:brightness(.4);}}" +
    ".dwpa-top{position:absolute;top:0;left:0;right:0;height:48px;background:linear-gradient(180deg,#ff4326,#ff6a00);border-bottom:3px dashed rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center;color:#170505;font-weight:700;letter-spacing:2px;font-size:13px;z-index:4;transform-origin:50% 100%;}" +
    ".dwpa-top.rip{animation:dwpaRip .55s cubic-bezier(.3,0,.4,1) forwards;}" +
    "@keyframes dwpaRip{0%{transform:translateY(0) rotate(0);}30%{transform:translateY(-6px) rotate(3deg);}100%{transform:translateY(-220px) rotate(38deg);opacity:0;}}" +
    ".dwpa-rim{position:absolute;top:46px;left:0;right:0;height:8px;background:repeating-linear-gradient(90deg,#ff6a00 0 7px,#2a0d0a 7px 13px);opacity:0;z-index:3;}" +
    ".dwpa-rim.show{opacity:1;}" +
    ".dwpa-logo{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;z-index:2;}" +
    ".dwpa-flame{font-size:62px;filter:drop-shadow(0 6px 16px rgba(255,90,30,.6));animation:dwpaPuls .8s ease-in-out infinite alternate;}" +
    "@keyframes dwpaPuls{0%{transform:scale(1) rotate(-3deg);}100%{transform:scale(1.12) rotate(3deg);}}" +
    ".dwpa-brand{font-weight:700;letter-spacing:3px;font-size:17px;color:#ffd9c4;}" +
    ".dwpa-sub{font-size:11px;letter-spacing:3px;color:#ff8a4c;}" +
    ".dwpa-hint{position:absolute;bottom:-2px;left:0;right:0;text-align:center;color:#e9c9bd;font-size:14px;letter-spacing:1px;font-family:'Inter',sans-serif;}" +
    ".dwpa-spark{position:absolute;color:#ffd27a;font-size:18px;opacity:0;z-index:5;pointer-events:none;}" +
    ".dwpa-spark.go{animation:dwpaSpark .8s ease-out forwards;}" +
    "@keyframes dwpaSpark{0%{opacity:1;transform:translate(0,0) scale(.5);}100%{opacity:0;transform:translate(var(--dx),var(--dy)) scale(1.3);}}";
  (document.head || document.documentElement).appendChild(css);

  var ov = document.createElement('div');
  ov.className = 'dwpa-ov';
  ov.innerHTML =
    '<div class="dwpa-stage">' +
      '<div class="dwpa-burst"></div>' +
      '<div class="dwpa-pack">' +
        '<div class="dwpa-top">DECKWÄCHTER</div>' +
        '<div class="dwpa-rim"></div>' +
        '<div class="dwpa-logo"><span class="dwpa-flame">🔥</span><span class="dwpa-brand">DECKWÄCHTER</span><span class="dwpa-sub">BOOSTER PACK</span></div>' +
      '</div>' +
      '<div class="dwpa-hint">Pack wird geöffnet …</div>' +
    '</div>';

  function mount() { if (!document.body) return setTimeout(mount, 40); document.body.appendChild(ov); }
  mount();

  var stage = ov.querySelector('.dwpa-stage');
  var animating = false;

  function packCount() {
    try { var s = JSON.parse(localStorage.getItem('dw_ps')); return s ? (s.p || 0) : 1; }
    catch (e) { return 1; }
  }

  function sparks() {
    for (var i = 0; i < 10; i++) {
      var s = document.createElement('span');
      s.className = 'dwpa-spark go';
      s.textContent = i % 2 ? '✦' : '✨';
      var ang = Math.random() * 6.28, dist = 90 + Math.random() * 70;
      s.style.setProperty('--dx', (Math.cos(ang) * dist).toFixed(0) + 'px');
      s.style.setProperty('--dy', (Math.sin(ang) * dist).toFixed(0) + 'px');
      stage.appendChild(s);
      (function (el) { setTimeout(function () { el.remove(); }, 850); })(s);
    }
  }

  function reset() {
    var old = ov.querySelector('.dwpa-pack');
    var fresh = old.cloneNode(true);
    fresh.className = 'dwpa-pack';
    fresh.querySelector('.dwpa-top').className = 'dwpa-top';
    fresh.querySelector('.dwpa-rim').className = 'dwpa-rim';
    old.parentNode.replaceChild(fresh, old);
    ov.querySelector('.dwpa-burst').className = 'dwpa-burst';
    ov.querySelector('.dwpa-hint').textContent = 'Pack wird geöffnet …';
    return fresh;
  }

  function play(done) {
    var pack = reset();
    ov.classList.remove('fade'); ov.classList.add('on');
    setTimeout(function () { pack.classList.add('shake'); }, 560);
    setTimeout(function () {
      pack.querySelector('.dwpa-top').classList.add('rip');
      pack.querySelector('.dwpa-rim').classList.add('show');
      ov.querySelector('.dwpa-burst').classList.add('go');
      sparks();
      ov.querySelector('.dwpa-hint').textContent = 'Aufgerissen!';
    }, 1200);
    setTimeout(function () {
      pack.classList.add('crumple');
      ov.querySelector('.dwpa-hint').textContent = 'Zusammengeknüllt & weggeworfen …';
    }, 1950);
    setTimeout(function () {
      ov.querySelector('.dwpa-hint').textContent = '✨ Deine Belohnung erscheint …';
      done();
    }, 2650);
  }

  function fadeOut() {
    ov.classList.add('fade');
    setTimeout(function () { ov.classList.remove('on'); ov.classList.remove('fade'); animating = false; }, 420);
  }

  function wrap() {
    if (!window.DW || typeof window.DW.open !== 'function') return setTimeout(wrap, 60);
    var orig = window.DW.open;
    window.DW.open = function () {
      if (animating) return;
      if (packCount() <= 0) { orig.apply(this, arguments); return; }
      animating = true;
      var self = this, args = arguments;
      play(function () {
        orig.apply(self, args);
        var rw = document.getElementById('dw-rw');
        var closed = false;
        function close() { if (closed) return; closed = true; if (obs) obs.disconnect(); fadeOut(); }
        var obs = null;
        if (rw && window.MutationObserver) {
          obs = new MutationObserver(function () { if (rw.classList.contains('on')) close(); });
          obs.observe(rw, { attributes: true, attributeFilter: ['class'] });
        }
        setTimeout(close, 1500);
      });
    };
  }
  wrap();
})();
